/* BBDP 2026-10-16 — Cartes produits : pastilles de coloris (mission « Cartes produits coloris et badges »).
   Option B (choix de Luc, 16/10) : toucher une pastille fait basculer la carte sur ce coloris
   (photo, nom, finition, prix, liens) sans quitter la liste ; la première pastille ramène au produit d'origine.
   Toucher la pastille déjà active, la photo ou le titre ouvre la fiche du coloris affiché.
   Ajouter ?bbdp_pastille=lien à l'URL pour revenir à l'option A (la pastille ouvre directement la fiche).
   Chaque toucher envoie l'événement bbdp_swatch_click dans le dataLayer (GTM).
   Aucune requête réseau : tout est déjà dans les attributs des pastilles. */
(function () {
  if (window.__bbdpSwatches) return;
  window.__bbdpSwatches = true;

  var mode = 'photo';
  try {
    var m = window.location.search.match(/[?&]bbdp_pastille=(photo|lien)\b/);
    if (m) sessionStorage.setItem('bbdp_pastille', m[1]);
    if (sessionStorage.getItem('bbdp_pastille') === 'lien') mode = 'lien';
  } catch (e) {}

  function setText(root, sel, value) {
    var el = root.querySelector(sel);
    if (el && value) el.textContent = value;
  }

  function apply(card, sw) {
    var href = sw.getAttribute('href');
    var img = card.querySelector('.card__media img');
    var src = sw.getAttribute('data-bbdp-img');
    if (img && src) {
      img.removeAttribute('loading');
      img.setAttribute('srcset', sw.getAttribute('data-bbdp-srcset') || src);
      img.setAttribute('src', src);
      img.setAttribute('alt', sw.getAttribute('aria-label') || '');
      var second = card.querySelectorAll('.card__media img')[1];
      if (second) second.style.display = 'none'; // la photo de survol est celle de l'ancien coloris
    }
    var info = card.querySelector('.bbdp-card-info');
    if (info) {
      setText(info, '.bbdp-card-title__type', sw.getAttribute('data-bbdp-type'));
      setText(info, '.bbdp-card-title__model', sw.getAttribute('data-bbdp-model'));
      setText(info, '.bbdp-card-title__finish', sw.getAttribute('data-bbdp-finish'));
      var full = info.querySelector('.bbdp-card-title__full');
      if (full) full.textContent = sw.getAttribute('data-bbdp-title');
      var price = sw.getAttribute('data-bbdp-price');
      var compare = sw.getAttribute('data-bbdp-compare');
      if (compare) {
        setText(info, '.price__sale .price-item--sale', price);
        setText(info, '.price__sale .price-item--regular', compare);
      } else {
        setText(info, '.price__regular .price-item--regular', price);
      }
    }
    var links = card.querySelectorAll('a.full-unstyled-link');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', href);
      links[i].setAttribute('title', sw.getAttribute('data-bbdp-title') || '');
    }
    var wish = card.querySelector('[data-bbdp-wishlist-slot]');
    if (wish) wish.setAttribute('data-bbdp-shown-handle', sw.getAttribute('data-bbdp-swatch'));
    var all = card.querySelectorAll('[data-bbdp-swatch]');
    for (var j = 0; j < all.length; j++) all[j].removeAttribute('aria-current');
    sw.setAttribute('aria-current', 'true');
  }

  document.addEventListener('click', function (event) {
    var sw = event.target.closest && event.target.closest('[data-bbdp-swatch]');
    if (!sw) return;
    var row = sw.closest('[data-bbdp-swatches]');
    var card = sw.closest('.card');
    var active = sw.getAttribute('aria-current') === 'true';

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bbdp_swatch_click',
        bbdp_swatch_from: row ? row.getAttribute('data-bbdp-from') : '',
        bbdp_swatch_to: sw.getAttribute('data-bbdp-swatch'),
        bbdp_swatch_mode: mode,
        bbdp_swatch_action: mode === 'lien' || active ? 'ouvre_fiche' : 'change_carte'
      });
    } catch (e) {}

    if (mode === 'lien' || active || !card) return; // on suit le lien vers la fiche
    event.preventDefault();
    apply(card, sw);
  });
})();
